/* eslint-disable */
/* eslint-disable no-param-reassign */
<template>
  <CartRestaurant v-if="$store.getters['theme/isRestaurantEnabled']" />
  <CartPickup v-else />
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import comminMixin from "../mixins/common";
import CartPickup from "./CartPickup.vue";
import CartRestaurant from "./CartRestaurant.vue";

export default {
  components: {
    CartPickup,
    CartRestaurant
  },
  mixins: [comminMixin],
  data: () => ({
    key: "cart",
    themeData: [],
    agree: false,
    payment: false,
    dialogSuccess: false,
    orderCompleted: false,
    collapse: {},
    editable: false,
    productRemarkActive: {},
    form: {
      order_remark: null,
    },
  }),

  async mounted() {
    if (this.orderData) {
      this.form = this.orderData;
    }

    // always set payment=true when QR is not restaurant
    if (!this.$store.getters['theme/isRestaurantEnabled']) {
      this.payment = true;
    }

    // The order in state.cart.order was already committed by SET_ORDER_DATA
    // from the POST response, so refetching it here re-downloaded the whole
    // order on every cart visit -- and twice per visit, because CartIndex and
    // the child it renders both did it. Nothing on this page reads a field of
    // that order, and the response grows with each round (~1.1 MB and rising),
    // so the refetch cost seconds on mobile to change nothing on screen.
    // Pages that do render order fields keep their own refetch: MyOrder and
    // PaymentOrderRestaurant.
  },

  methods: {
    handleReduceQty(prod) {
      const qty = prod.quantity;
      if (qty <= 1) {
        prod.quantity = 1;
      } else {
        prod.quantity = prod.quantity - 1;
      }
    },
    handleAddQty(prod) {
      prod.quantity = prod.quantity + 1;
    },
    showOrHide(key) {
      if (this.collapse && this.collapse[key]) {
        this.$set(this.collapse, key, !this.collapse[key]);
      } else {
        this.$set(this.collapse, key, true);
      }
    },
    pick(object, key) {
      return _.pick(object, key);
    },
    deleteProduct(productObject) {
      this.$store.dispatch("cart/deleteProduct", productObject);
    },
    async makeOrder() {
      if (this.$store.getters["session/getIsExpired"]) {
        this.$store.commit(
          "snackbar/error",
          "Session expired! To continue order, please contact our staff!",
          {
            root: true,
          }
        );
        return;
      }
      if (this.generalSetting.appSetting.payment) {
        // this.dialogSuccess = true;
        this.$router.push("/payment");
      } else {
        await this.$store.dispatch("cart/createOrder");
        if (!this.isOrderError) {
          this.orderCompleted = true;
        }
      }
    },

    async placeRestaurantOrder() {
      if (this.$store.getters['theme/isRestaurantEnabled'] && this.$store.getters["session/getIsExpired"]) {
        this.$store.commit(
          "snackbar/error",
          "Session expired! To continue order, please contact our staff!",
          {
            root: true,
          }
        );
        return;
      }

      // avoid to create multiple order for pickup (non restaurant QR)
      if (!this.$store.getters['theme/isRestaurantEnabled'] && this.order && this.order.id && !this.order.is_paid) {
        alert("You already have an order, but not paid yet, please complete the payment!");
        this.$router.push('/payment-order');
        return false;
      }

      await this.$store
        .dispatch("cart/placeRestaurantOrder")
        .then((response) => {
          if (this.payment) {
            console.log("PAYMENT CHECKED", this.payment);
            this.$router.push("/payment-order");
          }
        });
      if (!this.isOrderError) {
        this.orderCompleted = true;
      }
    },
  },
  computed: {
    ...mapState({
      cartProducts: (state) => state.cart.products,
      cart: (state) => state.cart,
      order: (state) => state.cart.order,
      isOrderLoading: (state) => state.cart.isOrderLoading,
      isOrderError: (state) => state.cart.isError,
      orderData: (state) => state.cart.data,
    }),
    ...mapState({
      dbData: (state) => state.theme.data,
    }),
    ...mapGetters({
      generalSetting: "theme/general",
    }),
    dataFromDb() {
      const data = {};
      this.dbData.forEach((item) => {
        data[item.key] = item.value;
      });
      return data;
    },
    headerStyle() {
      return {
        style: {
          color: this.themeData.totalOrderedItem.data.attr.style.color,
        },
        class: this.themeData.totalOrderedItem.data.attr.class,
      };
    },
    productStyle() {
      return {
        style: {
          color: this.themeData.totalOrderedItem.data.attr.style.color,
          fontSize: this.themeData.totalOrderedItem.data.attr.style.fontSize,
        },
        class: this.themeData.totalOrderedItem.data.attr.class,
      };
    },
    payNowButtonSetting() {
      return this.$store.getters["theme/cart"].payNowButton;
    },
  },
  watch: {
    orderData: {
      handler(newValue) {
        this.form = newValue;
      },
      deep: true,
    },
    form: {
      handler(newValue) {
        this.$store.dispatch("cart/setOrderData", newValue);
      },
      deep: true,
    },
    themeData: {
      handler(newValue) {
        if (newValue && newValue.orderConfirmationDialog) {
          if (window.location !== window.parent.location) {
            // execute this for preview only
            this.dialogSuccess =
              newValue.orderConfirmationDialog.data.showPreview;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
/* For Firefox */

input[type="number"] {
  -moz-appearance: textfield;
}

/* Webkit browsers like Safari and Chrome */

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.ql-editor .ql-align-center img {
  width: auto !important;
}
</style>
